import { generateUtilityClass } from './utils/generate-utility-class';
import { generateUtilityClasses } from './utils/generate-utility-classes';

export const RICH_TEXT_COMPONENT_NAME = 'kaltura-ds-richtext';

export function getRichTextClass(slot: string) {
  return generateUtilityClass(RICH_TEXT_COMPONENT_NAME, slot);
}

export interface RichTextClasses {
  /**  styles applied to the root element */
  root: string;
  /** Styles applied to the rich text element. */
  richText: string;
  /** Styles applied to the toolbar element. */
  toolbar: string;
  /** Styles applied to the root element if `readOnly={true}`. */
  readOnly: string;
  /** State class applied to the root element if `error={true}`. */
  error: string;
  /** Styles applied to the root element if the component is focused. */
  focused: string;
}
export type RichTextClassKey = keyof RichTextClasses;

export const richTextClasses = generateUtilityClasses(
  RICH_TEXT_COMPONENT_NAME,
  ['root', 'richText', 'toolbar', 'readOnly', 'error', 'focused']
);

export default richTextClasses;
